import axios from 'axios';
import { IDeviation } from '@/shared/model/deviation.model';

const baseApiUrl = 'api/deviations';

export default class DeviationService {
  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(deviation: IDeviation): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(baseApiUrl, deviation)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
